import { useState, useEffect } from "react"
import { useUpdateProfileMutation, useDeleteUserMutation } from "./usersApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave, faUpload } from "@fortawesome/free-solid-svg-icons"
import { SETTINGS } from "../../config/settings"
import getFilePath from "../../utils/getFilePath"
const PWD_REGEX = /^[A-z0-9!@#$%]{4,12}$/

const EditProfileForm = ({user}) => {
    const {groupId, type} = useParams()
    const [updateProfile, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateProfileMutation()

   

    const navigate = useNavigate()


    const [password, setPassword] = useState('')
    const [validPassword, setValidPassword] = useState(false)
    const [email, setEmail] = useState(user.email)
    const [name, setName] = useState(user.name)
    const [phone, setPhone] = useState(user.phone||"")
    const [settings, setSettings] = useState(user.settings)
    const [image, setImage] = useState(user.image)
    const [imageFile, setImageFile] = useState(null)

    useEffect(() => {
        setValidPassword(PWD_REGEX.test(password))
    }, [password])

    useEffect(() => {
        if (isSuccess ) {
            setPassword('')
            setEmail('')
            setName('')
            setPhone('')
            navigate(`/${type}/${groupId}/`)
        }

    }, [isSuccess,  navigate])
    const onPasswordChanged = e => setPassword(e.target.value)
 
    const onSaveUserClicked = async (e) => {
        const formData = new FormData()

        formData.append('id', user._id)
        formData.append('name', name)
        formData.append('phone', phone)
        formData.append('email', email)
        formData.append('settings', JSON.stringify(settings))
        formData.append('image', image?image:'')
        formData.append('file', imageFile)
        if (password) {
            formData.append('password', password)
        }
        await updateProfile(formData)
        // if (password) {
        //     await updateProfile({ id: user._id, password, name, email, phone, settings })
        // } else {
        //     await updateProfile({ id: user._id,  name, email, phone, settings })
        // }
    }
    const onImageChange = e=>{
        const files = e.target.files;
        if(files.length > 0){
            //console.log(e.target.files[0])
            setImageFile(e.target.files[0])
            setImage(null)
        }
        e.target.value = ''
    }
   

    const handleSettingsCheck = (event) => {
        var updatedList = [...settings];
        if (event.target.checked) {
          updatedList = [...settings, event.target.value];
        } else {
          updatedList.splice(settings.indexOf(event.target.value), 1);
        }
        setSettings(updatedList);
      };


    let canSave
    if (password) {
        canSave = [validPassword , name,email].every(Boolean) && !isLoading
    } else {
        canSave = [ name,email].every(Boolean) && !isLoading
    }

    const errClass = (isError) ? "errmsg" : "offscreen"
    const validPwdClass = password && !validPassword ? 'form__input--incomplete' : ''
    const errContent = (error?.data?.message ) ?? ''
    // Return classes based on whether item is checked
    var isChecked = (item) =>
        settings.includes(item.id) ? "checked-item" : "not-checked-item";

    const content = (
        <>
            <p className={errClass}>{errContent}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit Profile</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveUserClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>                       
                    </div>
                </div>
                <label className="form__label" htmlFor="username">
                    Username: </label>
                <input
                    readOnly
                    disabled
                    className={`form__input`}
                    id="username"
                    name="username"
                    type="text"
                    autoComplete="off"
                    value={user.username}
                />

                <label className="form__label" htmlFor="password">
                    סיסמא: <span className="nowrap">[ריקה = ללא שינוי]</span> <span className="nowrap">[4-12 תווים כולל. !@#$%]</span></label>
                <input
                    className={`form__input ${validPwdClass}`}
                    id="password"
                    name="password"
                    type="password"
                    value={password}
                    onChange={onPasswordChanged}
                />
                
                <label className="form__label" htmlFor="name">
                    שם: </label>
                <input
                    className={`form__input ${!name &&'form__input--incomplete'}`}
                    id="name"
                    name="name"                    
                    type="text"
                    value={name}
                    onChange={(e)=>{setName(e.target.value)}}
                />
                <label className="form__label" htmlFor="email">
                    דואר אלקטרוני: </label>
                <input
                    className={`form__input ${!email &&'form__input--incomplete'}`}
                    id="email"
                    email="email"                    
                    type="email"
                    value={email}
                    onChange={(e)=>{setEmail(e.target.value)}}
                />
                <label className="form__label" htmlFor="image">
                    תמונה  ריבועית עד 2 מגה: </label>
                {image && <div className="profile-image-container"> <img src={getFilePath(image)} /><a onClick={()=>setImage(null)}>הסר</a> </div>}
                {imageFile && <div className="d-flex">   <FontAwesomeIcon icon={faUpload} /> &nbsp; {imageFile.name} </div>}
                {(process.env.REACT_APP_STUDENT_CAN_ADD_PROFILE_PICTURE==='true') &&  <input  type="file" id="image" name="image" accept="image/*" onChange={onImageChange} />}
                <label className="form__label" htmlFor="phone">
                    נייד: </label>
                <input
                    className={`form__input`}
                    id="phone"
                    name="phone"                    
                    type="text"
                    value={phone}
                    onChange={(e)=>{setPhone(e.target.value)}}
                />

            <div className="list-container">
                {SETTINGS.map((item, index) => (
                    <label key={item.id}>
                        <input value={item.id} type="checkbox"
                            defaultChecked={ settings.includes(item.id)}
                            onChange={handleSettingsCheck}
                        />
                       <span className={isChecked(item)}>{item.name}</span>
                    </label>
                ))}
            </div>

              

               
                

            </form>
        </>
    )

    return content
}
export default EditProfileForm